export const ATTENDANCE_MESSAGE = Object.freeze({
  FIRST: {
    title: '첫 출석체크',
    content: '첫 출석을 완료하고 포인트를 받아요',
  },
  CONSECUTIVE: {
    title: '연속 출석 포인트',
    content: '연속으로 출석하고 25 포인트를 받아요',
  },
});
